import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-gestion-medicament-pharmacie',
  templateUrl: './gestion-medicament-pharmacie.component.html',
  styleUrls: ['./gestion-medicament-pharmacie.component.scss']
})
export class GestionMedicamentPharmacieComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }


 open(id:number){
  this.router.navigate(['gestion-med-par-pharmacie/'+id]);    
}
//287732    2205
//340909   1605340

}